// ** React Imports
import { useEffect, useState } from 'react'

// ** MUI Imports
import {
  Box,
  Card,
  CardHeader,
  Divider,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material'

// ** Utils
import axios from 'axios'
import apiUrl from '../../../configs/constant'
import { useToast } from '../../../components/ToastProvider'
import Icon from '../../../components/icon'
import Swal from 'sweetalert2'

export default function Index() {
  const userData = JSON.parse(localStorage.getItem('user')!)
  const token = userData.token
  const { showToast } = useToast()

  const [listData, setListData] = useState<any[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getData()
  }, [])

  const getData = () => {
    setLoading(true)
    const url = apiUrl.apiUrl + '/production/planning-produksi/list-prioritas/17'
    axios
      .get(url, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        if (res.data.success) {
          setListData(res.data.data)
        } else {
          showToast(res.data.message, 'error')
        }
      })
      .finally(() => setLoading(false))
  }

  // ==========================
  // MOVE ROW
  // ==========================
  const moveItem = (index: number, direction: 'up' | 'down') => {
    setListData(prev => {
      const target = direction === 'up' ? index - 1 : index + 1
      if (target < 0 || target >= prev.length) return prev

      const clone = [...prev]
      ;[clone[index], clone[target]] = [clone[target], clone[index]]
      return clone
    })
  }

  const savePrioritas = (row :any,is_up :any) => {
    const url = apiUrl.apiUrl + '/production/planning-produksi/save-prioritas'
            axios
                .post(url, {
                  wo_id : row.id,
                  is_up : is_up,
                  keterangan : '',
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                })
                .then(response => {
                    if (response.data.success) {
                        showToast(response.data.message, 'success');
                    } else {
                        showToast(response.data.message, 'error');
                    }
                })
                .catch(error => {
                    showToast(error.message, 'error');
                })
  }

  // ==========================
  // TIMELINE COMPONENT
  // ==========================
  const Timeline = ({ steps }: { steps: any[] }) => {
    console.log(steps)
    if (!steps?.length)
      return <Typography color="text.secondary">Belum ada proses</Typography>

    const color = (p: number) =>
      p === 100 ? '#2ecc71' : p > 0 ? '#f39c12' : '#bdc3c7'

    return (
      <Box sx={{ display: 'flex', gap: 2, overflowX: 'auto', py: 1 }}>
        {steps.map((s, i) => (
          <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box
              sx={{
                minWidth: 150,
                p: 1.5,
                borderRadius: 2,
                bgcolor: '#fff',
                boxShadow: 2,
                borderTop: `5px solid ${color(s.persen_hasil)}`
              }}
            >
              <Typography fontWeight={700} fontSize={13}>
                {s.proses}
              </Typography>
              <Typography fontSize={11} color="text.secondary">
                {s.tgl_realisasi ? `${s.tgl_realisasi} - ` : ''}
                {s.tgl_selesai || '-'}
              </Typography>

              <Typography fontSize={12} mt={1}>
                {s.persen_hasil}%
              </Typography>

              <Box sx={{ height: 5, bgcolor: '#eee', borderRadius: 2, mt: 0.5 }}>
                <Box
                  sx={{
                    height: '100%',
                    width: `${s.persen_hasil}%`,
                    bgcolor: color(s.persen_hasil),
                    borderRadius: 2,
                    transition: 'all .3s'
                  }}
                />
              </Box>
            </Box>

            {i < steps.length - 1 && (
              <Typography color="#bbb" fontSize={18}>
                ➜
              </Typography>
            )}
          </Box>
        ))}
      </Box>
    )
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card sx={{ borderRadius: 3 }}>
          {/* <CardHeader title="PLANNING PRODUKSI RANGKAH" /> */}
          {/* <Divider /> */}

          {loading ? (
            <Box sx={{ p: 6, textAlign: 'center' }}>
              <CircularProgress />
            </Box>
          ) : (
            <TableContainer component={Paper} sx={{ borderRadius: 0 }}>
              <Table size="small">
                <TableHead sx={{ bgcolor: '#1e272e' }}>
                  <TableRow>
                    <TableCell sx={{ color: '#fff' }}>Aksi</TableCell>
                    <TableCell sx={{ color: '#fff' }}>Produk</TableCell>
                    <TableCell sx={{ color: '#fff' }}>Timeline Produksi</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {listData.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        bgcolor: row.is_target === 1 ? '#f6e58d' : 'inherit',
                        '&:hover': { bgcolor: '#f1f2f6' }
                      }}
                    >
                      {/* AKSI */}
                      <TableCell>
                        <Box>
                          <Tooltip title="Naik">
                            <IconButton
                              disabled={index === 0}
                              onClick={() => {
                                moveItem(index, 'up')
                                savePrioritas(row,1 )
                              }}
                              sx={{ color: '#2ecc71' }}
                            >
                              <Icon icon="mdi:arrow-up-bold" />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="Turun">
                            <IconButton
                              disabled={index === listData.length - 1}
                              onClick={() => {
                                moveItem(index, 'down')
                                savePrioritas(row,0)
                              }}
                              sx={{ color: '#e74c3c' }}
                            >
                              <Icon icon="mdi:arrow-down-bold" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>

                      {/* PRODUK */}
                      <TableCell>
                        <Box
                          onClick={() => {
                            Swal.fire({
                              title: row.produk || 'Detail Produk',
                              imageUrl: row.link,
                              imageAlt: row.produk,
                              imageWidth: 300,
                              imageHeight: 300,
                              showConfirmButton: true,
                              confirmButtonText: 'Tutup',
                              confirmButtonColor: '#2ecc71',
                            })
                          }}
                          sx={{
                            cursor: 'pointer',
                            '&:hover': {
                              backgroundColor: '#f1f2f6',
                              borderRadius: 1,
                            },
                          }}
                        >
                          <Typography fontWeight={600}>
                            {row.kode || ''}
                          </Typography>
                          <Typography fontSize={12} color="text.secondary">
                            {row.produk || '-'}
                          </Typography>
                          <Typography fontSize={12} color="text.secondary">
                            {row.qty || '-'} PCS
                          </Typography>
                        </Box>
                      </TableCell>

                      {/* TIMELINE */}
                      <TableCell>
                        <Timeline steps={row.steps || []} />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Card>
      </Grid>
    </Grid>
  )
}
